import { Slot, Skeleton, Anchor } from '@costar-ui/components';
import { IconLinkedin2 } from '@costar-ui/icons/csg/IconLinkedin2';
import { IconMail } from '@costar-ui/icons/csg/IconMail';
import { IconContactMail } from '@costar-ui/icons/md/IconContactMail';
import React from 'react';

var onIconLinkClick = function onIconLinkClick(e) {
  return e.stopPropagation();
};
var SocialIconLinks = function SocialIconLinks(props) {
  var email = props.email,
    onEmailClick = props.onEmailClick,
    linkedInProfile = props.linkedInProfile,
    vCard = props.vCard,
    isLoading = props.isLoading,
    testId = props.testId;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(Slot, {
    alignItems: "center",
    gap: "sm",
    className: "csg-tw-skeleton-social-icon-links"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: "1.25",
    width: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: "1.25",
    width: "1.25"
  })) : (onEmailClick || email || vCard || linkedInProfile) && /*#__PURE__*/React.createElement(Slot, {
    alignItems: "center",
    gap: "sm",
    className: "h-5",
    "data-testid": testId
  }, onEmailClick ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "neutral",
    onClick: onEmailClick,
    testId: "email-link"
  }, /*#__PURE__*/React.createElement(IconMail, {
    size: "1.5rem"
  })) : email ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "neutral",
    href: "mailto:".concat(email),
    onClick: onIconLinkClick,
    testId: "email-link"
  }, /*#__PURE__*/React.createElement(IconMail, {
    size: "1.5rem"
  })) : null, vCard ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "neutral",
    href: vCard,
    onClick: onIconLinkClick,
    target: "_blank",
    testId: "vCard-link"
  }, /*#__PURE__*/React.createElement(IconContactMail, {
    size: "1.5rem"
  })) : null, linkedInProfile ? /*#__PURE__*/React.createElement(Anchor, {
    variant: "neutral",
    href: linkedInProfile,
    onClick: onIconLinkClick,
    target: "_blank",
    testId: "linkedin-link"
  }, /*#__PURE__*/React.createElement(IconLinkedin2, {
    width: "1.19rem",
    height: "1.13rem"
  })) : null));
};
var SocialIconLinks$1 = SocialIconLinks;

export { SocialIconLinks$1 as default };
//# sourceMappingURL=social-icon-links.esm.js.map
